var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file Group
 * @author (zhuwanying02)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash-es';
import { classPrefix } from '../../common/util';

import './Group.less';

var Group = function (_Component) {
    _inherits(Group, _Component);

    function Group(props) {
        _classCallCheck(this, Group);

        var _this = _possibleConstructorReturn(this, (Group.__proto__ || Object.getPrototypeOf(Group)).call(this, props));

        var multiple = props.multiple,
            value = props.value,
            optionData = props.optionData,
            optionHoverd = props.optionHoverd;


        _this.state = {
            value: value || (multiple ? [] : ''),
            optionHoverd: optionHoverd || ''
        };

        _this.multipleOptions = [];

        if (multiple && value.length > 0) {
            _this.setMultipleOptions(value, optionData);
        }
        return _this;
    }

    _createClass(Group, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(newProps) {
            var value = newProps.value,
                optionData = newProps.optionData,
                optionHoverd = newProps.optionHoverd;


            if (value && value !== this.props.value) {
                this.setState({
                    value: newProps.value
                });
            }

            if (!_.isEqual(optionData, this.props.optionData)) {
                this.setState({
                    optionData: newProps.optionData
                });
            }

            if (optionHoverd && optionHoverd !== this.props.optionHoverd) {
                this.setState({
                    optionHoverd: newProps.optionHoverd
                });
            }
        }
    }, {
        key: 'setMultipleOptions',
        value: function setMultipleOptions(value, optionData) {
            var optionDataArr = optionData.map(function (v) {
                return v.children;
            });
            optionDataArr = _.flattenDeep(optionDataArr);

            var arr = value.map(function (v) {
                return optionDataArr.filter(function (item) {
                    return v === item.value;
                })[0];
            });
            arr = arr.filter(function (v) {
                return v;
            });

            this.multipleOptions = arr;
        }
    }, {
        key: 'handleOptionClick',
        value: function handleOptionClick(child, event) {
            var _props = this.props,
                multiple = _props.multiple,
                onHandleChange = _props.onHandleChange,
                singleSelect = _props.singleSelect,
                toggleDropdownVisible = _props.toggleDropdownVisible;

            var value = this.state.value;

            if (child.disabled) {
                return;
            }
            if (onHandleChange && _.isFunction(onHandleChange)) {
                var data = {};
                if (multiple) {
                    var index = value.indexOf(child.value);

                    if (index > -1) {
                        // 删除
                        for (var i = 0, len = this.multipleOptions.length; i < len; i++) {
                            if (this.multipleOptions[i].value === child.value) {
                                this.multipleOptions.splice(i, 1);
                                break;
                            }
                        }
                        value.splice(index, 1);
                    } else {
                        this.multipleOptions.push(child);
                        value.push(child.value);
                    }

                    this.setState({
                        value: value
                    });

                    data.multiple = true;
                    data.result = this.multipleOptions;
                } else {
                    data.multiple = false;
                    data.result = child;

                    this.setState({
                        value: child.value
                    });

                    if (singleSelect) {
                        toggleDropdownVisible(event);
                    }
                }
                onHandleChange(data);
            }
        }
    }, {
        key: 'handleOptionHover',
        value: function handleOptionHover(type, data) {
            var onHandleMouseEnter = this.props.onHandleMouseEnter;
            if (type === 'enter') {
                // mouse enter
                if (onHandleMouseEnter && _.isFunction(onHandleMouseEnter)) {
                    onHandleMouseEnter(data);
                } else {
                    this.setState({
                        optionHoverd: data.value
                    });
                }
            } else {
                // mouse leave
                this.setState({
                    optionHoverd: ''
                });
            }
        }
    }, {
        key: 'renderGroup',
        value: function renderGroup() {
            var _this2 = this;

            var _props2 = this.props,
                multiple = _props2.multiple,
                optionData = _props2.optionData,
                classPrefix = _props2.classPrefix;
            var _state = this.state,
                value = _state.value,
                optionHoverd = _state.optionHoverd;


            return optionData.map(function (v, i) {
                return React.createElement(
                    'div',
                    { className: classPrefix + '-group-item', key: 'group_' + i },
                    React.createElement(
                        'div',
                        { className: classPrefix + '-group-title' },
                        v.title
                    ),
                    v.children.map(function (child) {
                        var _classnames;

                        var isSelected = false;
                        if (!v.disabled) {
                            if (multiple) {
                                isSelected = !(value.indexOf(child.value) === -1);
                            } else {
                                isSelected = value === child.value;
                            }
                        } else {
                            isSelected = false;
                        }
                        var optionClass = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-group-option', true), _defineProperty(_classnames, classPrefix + '-group-option-hover', !child.disabled && optionHoverd === child.value), _defineProperty(_classnames, classPrefix + '-group-option-selected', isSelected), _defineProperty(_classnames, classPrefix + '-group-option-disable', child.disabled), _classnames));
                        var multiSelectIconClass = classnames(_defineProperty({}, classPrefix + '-group-option-multi-selected', multiple & isSelected));

                        return React.createElement(
                            'div',
                            {
                                className: optionClass,
                                key: child.value,
                                onMouseEnter: _this2.handleOptionHover.bind(_this2, 'enter', child),
                                onMouseLeave: _this2.handleOptionHover.bind(_this2, 'leave'),
                                onClick: function onClick(event) {
                                    return _this2.handleOptionClick(child, event);
                                }
                            },
                            React.createElement(
                                'span',
                                null,
                                child.name
                            ),
                            React.createElement('span', { className: multiSelectIconClass }),
                            child.icon && React.createElement(
                                'span',
                                { className: classPrefix + '-group-option-icon' },
                                React.createElement('i', { className: child.icon })
                            )
                        );
                    })
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                className = _props3.className,
                width = _props3.width,
                classPrefix = _props3.classPrefix;


            var dClass = classnames(className, _defineProperty({}, classPrefix + '-group-box', true));
            var style = width && { width: width };

            return React.createElement(
                'div',
                { className: dClass, style: style },
                this.renderGroup()
            );
        }
    }]);

    return Group;
}(Component);

export default Group;


Group.defaultProps = {
    optionData: [],
    className: '',
    width: 120,
    multiple: false,
    value: '',
    classPrefix: classPrefix
};

Group.propTypes = {
    onHandleChange: PropTypes.func.isRequired,
    optionData: PropTypes.arrayOf(PropTypes.object).isRequired,
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    multiple: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    optionHoverd: PropTypes.string,
    singleSelect: PropTypes.bool,
    toggleDropdownVisible: PropTypes.func.isRequired,
    onHandleMouseEnter: PropTypes.func,
    classPrefix: PropTypes.string
};